<template>
  <div>
    <a-card class="customer-filter">
      <story-filter-form ref="filterFormRef" v-model="filterForm" @change="handleChange" @reset="onReset" />
    </a-card>
    <a-card title="需求列表" size="small" class="filter-data">
      <span slot="extra">
        <story-view ref="view" @setFilter="setFilter" />
        <span class="add">
          <a-dropdown size="small">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <span style="color: #1890ff"><a-icon type="plus" /> 添加 </span><a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <a v-tc="{ name: '添加需求' }" @click="onAdd(false)">需求</a>
              </a-menu-item>
              <a-menu-item key="2">
                <a v-tc="{ name: '添加故事' }" @click="onAdd(true)">故事</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </span>
      <story-data-list ref="storyDataListRef" type="story" />
    </a-card>
    <story-edit :data-source="storyData" :visible="editVisible" :story-id="storyId" :parent="parent" :version-id="versionId" :is-story="isStory" @close="close" />
  </div>
</template>
<script>
import StoryEdit from '@/pages/project/story/components/StoryEdit';
import StoryView from '@/pages/project/story/components/StoryView';
import StoryDataList from '@/pages/project/story/components/StoryDataList';
import StoryFilterForm from '@/pages/project/story/components/StoryFilterForm';

export default {
  components: { StoryEdit, StoryDataList, StoryView, StoryFilterForm },
  data() {
    return {
      isStory: false,
      editVisible: false,
      storyId: null,
      versionId: null,
      parent: {},
      storyData: {},
      filterForm: {}
    };
  },
  methods: {
    onAdd(isStory = false) {
      this.isStory = isStory;
      this.editVisible = true;
    },

    handleChange(filter) {
      this.$nextTick(() => {
        this.$refs.storyDataListRef.setFilter(filter);
      });
    },

    setFilter(filter) {
      this.filterForm = {
        ...filter
      };
      this.handleChange(filter);
    },

    close() {
      this.editVisible = false;
      this.storyId = null;
      this.versionId = null;
      this.parent = {};
      this.storyData = {};
      this.handleChange(this.filterForm);
    },

    onReset(filter) {
      this.setFilter({ ...filter });
      this.$nextTick(() => {
        this.$refs.storyDataListRef.pagination.pageSize = this.$store.getters.pageSize;
        this.$refs.view.resetView();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.add {
  float: left;
  line-height: 32px;
  margin-left: 10px;
}

.filter-data {
  margin-top: 16px;
}

/deep/.customer-filter .ant-card-body {
  padding: 12px !important;
}
</style>
